export default "__VITE_ASSET__C8dCq554__"